const cocktails = [
    "Martini",
    "Margarita",
    "Old Fashioned",
    "Negroni",
    "Cosmopolitan",
    "Mojito",
    "Manhattan",
    "Daiquiri",
    "Whiskey Sour",
    "Gin and Tonic",
    "Piña Colada",
    "Moscow Mule",
    "Bloody Mary",
    "Bellini",
    "Sangria",
    "Mai Tai",
    "Mimosa",
    "White Russian",
    "French 75",
    "Caipirinha",
    "Tom Collins",
    "Espresso Martini",
    "Aperol Spritz",
    "Mint Julep",
    "Paloma",
    "Sidecar",
    "Sazerac",
    "Gimlet",
    "Irish Coffee",
    "Amaretto Sour",
    "Pisco Sour",
    "Sex on the Beach",
    "Black Russian",
    "Long Island Iced Tea",
    "Mai Tai",
    "Gin Fizz",
    "Ginger Beer Cocktail",
    "Blue Lagoon",
    "Pisco Sour",
    "Screwdriver",
    "Tequila Sunrise",
    "Dark and Stormy",
    "White Lady",
    "Bellini",
    "Mango Margarita",
    "Gin Martini",
    "Whiskey Smash",
    "Pimm's Cup",
    "Singapore Sling",
    "Mudslide",
    "Kir Royale",
    "Caipiroska",
    "Zombie",
    "Planter's Punch",
    "Mai Tai",
    "Grasshopper",
    "Rob Roy",
    "Corpse Reviver No. 2",
    "Vodka Martini",
    "Cuba Libre",
    "Tequila Sunset",
    "French Martini",
    "Rum Punch",
    "Tommy's Margarita",
    "Boulevardier",
    "Rusty Nail",
    "Peach Bellini",
    "Blood and Sand",
    "Hurricane",
    "Mai Tai",
    "Pisco Sour",
    "Gin and Tonic",
    "Whiskey Sour",
    "Blue Hawaiian",
    "Cranberry Vodka Cocktail",
    "Moscow Mule",
    "Ramos Gin Fizz",
    "Long Island Iced Tea",
    "Black Russian",
    "Tom Collins",
    "Strawberry Daiquiri",
    "Tequila Sunrise",
    "Piña Colada",
    "Dark and Stormy",
    "Amaretto Sour",
    "Sazerac",
    "Mint Julep",
    "Paloma",
    "Caipirinha",
    "Espresso Martini",
    "Negroni",
    "Margarita"
]

export default cocktails